import { router } from 'utilities';
import { AuthenticationProvider, ThemeProvider, RouterProvider } from 'providers';

export default function App() {
  return (
    <AuthenticationProvider>
      <ThemeProvider>
        <RouterProvider router={router} />
      </ThemeProvider>
    </AuthenticationProvider>
  );
}